import * as config from 'config/config';

export const isFeatureEnabled = (featureFlag) => {
  return config[featureFlag] || false;
};
